import WebFullScreenImageViewer from "./FullScreenImageViewer.web";
import NativeFullScreenImageViewer from "./FullScreenImageViewer.native";
import { Platform } from "react-native";

export default Platform.OS === "web" ? WebFullScreenImageViewer : NativeFullScreenImageViewer;
